import React from 'react';
import './PageLoader.scss';

export const SpinIndicator = () => <div className="page-loader__ring" />;

const PageLoader = ({ tip }) => (
  <div className="page-loader">
    <SpinIndicator />
    {tip && <span className="page-loader__tip">{tip}</span>}
  </div>
);

export default PageLoader;
